import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ReAccountingStatusPicker } from '../../../../components/entity-picker/re-accounting-status-picker/ReAccountingStatusPicker';
import { FilterCard } from '../filter-card/FilterCard';

type Props = {
  title: string;
  value: { id: string; name: string }[] | null;
  onChange: (value: { id: string; name: string }[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
};

export const ReAccountingStatusFilterCard: React.FC<Props> = (props) => {
  const { title, value, onChange, expanded, onExpandedChange } = props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    if (value.length === 1) return t(`RE.ACCOUNTING_STATUSES.${value[0].id}`);
    return t('COMMON.CHOSEN', { count: value.length });
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <ReAccountingStatusPicker
        multiple={true}
        value={value}
        onChange={onChange}
      />
    </FilterCard>
  );
};
